import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";

/* ---------- CONSTANTS ---------- */
const MAX_LENGTH = 500;
const SCROLL_THRESHOLD = 1000;

const QuickLinksTabs = ({ tabContent }) => {
  const [activeTab, setActiveTab] = useState("mission");
  const [expanded, setExpanded] = useState({});

  const toggleReadMore = (key) => {
    setExpanded((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const renderText = (key, text) => {
    const isLong = text.length > MAX_LENGTH;
    const isVeryLong = text.length > SCROLL_THRESHOLD;
    const isExpanded = expanded[key];

    return (
      <>
        <div
          className={isVeryLong ? "ql-scroll" : ""}
          style={{
            maxHeight: isVeryLong ? "220px" : "none",
            overflowY: isVeryLong ? "auto" : "visible",
            paddingRight: isVeryLong ? "8px" : "0",
            marginBottom: "8px",
          }}
        >
          <p style={{ color: "#333", lineHeight: "1.7", marginBottom: 0 }}>
            {isLong && !isExpanded && !isVeryLong
              ? text.slice(0, MAX_LENGTH) + "..."
              : text}
          </p>
        </div>

        {/* Read more shown ONLY for medium-length text */}
        {isLong && !isVeryLong && (
          <span
            onClick={() => toggleReadMore(key)}
            style={{
              color: "#024621",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            {isExpanded ? "Read less" : "Read more"}
          </span>
        )}
      </>
    );
  };

  return (
    <>
      {/* ---------- SCROLLBAR STYLES ---------- */}
      <style>{`
        .ql-scroll::-webkit-scrollbar {
          width: 6px;
        }
        .ql-scroll::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 8px;
        }
        .ql-scroll::-webkit-scrollbar-thumb {
          background: #024621;
          border-radius: 8px;
        }
        .ql-scroll::-webkit-scrollbar-thumb:hover {
          background: #012f17;
        }

        .quick-links-tabs .nav-tabs .nav-link.active {
          color: #024621 !important;
          border-color: #024621 #024621 #fff !important;
          font-weight: 600;
        }

        .quick-links-tabs .nav-tabs .nav-link:hover {
          color: #024621;
        }
      `}</style>

      <div
        className="quick-links-tabs"
        style={{
          background: "#ffffff",
          borderRadius: "14px",
          padding: "20px",
          border: "2px solid #024621",
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
          height: "450px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* ---------- HEADER ---------- */}
        <h5
          style={{
            fontWeight: "700",
            marginBottom: "12px",
            color: "#024621",
            borderBottom: "2px solid #024621",
            paddingBottom: "6px",
          }}
        >
          QUICK LINKS
        </h5>

        {/* ---------- TABS ---------- */}
        <Tabs
          id="quick-links-tabs"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
          justify
          mountOnEnter
        >
          <Tab eventKey="mission" title="Mission">
            {renderText("mission", tabContent.mission.text)}
          </Tab>

          <Tab eventKey="vision" title="Vision">
            {renderText("vision", tabContent.vision.text)}
          </Tab>

          <Tab eventKey="objective" title="Objective">
            {renderText("objective", tabContent.objective.text)}
          </Tab>

          <Tab eventKey="aboutCollege" title="About College">
            {renderText("aboutCollege", tabContent.aboutCollege.text)}
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default QuickLinksTabs;
